import React, { useContext } from "react";
import { FiX } from "react-icons/fi";
import Button from "@material-ui/core/Button";

import { WizardContext } from "../index";
import Stepper from "./Stepper";
import { Container, Title } from "./styles";

function Header({ title = "", onClose = () => {} }) {
  const { state, dispatch } = useContext(WizardContext);

  return (
    <Container>
      <Stepper
        stepsQtd={state.listOfSteps.length}
        activeStep={state.actualStep}
      />
      <Title>{title}</Title>
      <Button variant="outlined" onClick={onClose} size="large">
        <FiX />
      </Button>
    </Container>
  );
}

export default Header;
